var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.016 .195)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffce6e",
    transform: "translate(.016 -.195)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff462e",
    d: "M35.127 5.689h-1.9V1.422A1.435 1.435 0 0 0 31.808 0H1.422A1.435 1.435 0 0 0 0 1.422v17.714a1.435 1.435 0 0 0 1.422 1.422h30.343a1.435 1.435 0 0 0 1.422-1.422V14.87h1.9a1.435 1.435 0 0 0 1.422-1.422V7.112a1.371 1.371 0 0 0-1.382-1.423zM16.981 14.4l-2.371-4.138-6.336.6 7.93-4.741 2.371 4.267 6.336-.6z",
    transform: "rotate(-90 33.848 14.183)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.fdef1663934e89697fd097ee3503632d.svg";
export { ForwardRef as ReactComponent };